"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyBox = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _skybaseComponents = require("skybase-ui/skybase-components");

var _copyToClipboard = require("skybase-ui/skybase-core/utils/copy-to-clipboard");

var _shapes = require("skybase-ui/skybase-core/shapes");

var _copyBoxI18n = require("./copy-box-i18n");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _CopyBox = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(_CopyBox, _PureComponent);

  var _super = _createSuper(_CopyBox);

  function _CopyBox(props) {
    var _this;

    (0, _classCallCheck2.default)(this, _CopyBox);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "copyTimer", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCopyToClipboard", function () {
      var _this$props = _this.props,
          text = _this$props.text,
          textToCopy = _this$props.textToCopy;

      if ((0, _copyToClipboard.copyToClipboard)(textToCopy || text)) {
        _this.setState({
          copiedToClipboard: true
        });

        _this.copyTimer = setTimeout(function () {
          _this.setState({
            copiedToClipboard: false
          });
        }, 3000);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderCopyToClipboardHintContent", function () {
      var copiedToClipboard = _this.state.copiedToClipboard;
      var _this$props2 = _this.props,
          copyToClipboardText = _this$props2.copyToClipboardText,
          _ = _this$props2.intl.formatMessage;
      return copiedToClipboard ? /*#__PURE__*/_react.default.createElement("div", {
        className: "copy-success"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-toast-success m-r-5"
      }), _(_copyBoxI18n.messages.copied)) : copyToClipboardText || _(_copyBoxI18n.messages.copyToClipboard);
    });
    _this.state = {
      copiedToClipboard: false
    };
    return _this;
  }

  (0, _createClass2.default)(_CopyBox, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.copyTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var text = this.props.text;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "copy-box"
      }, text, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbHint, {
        position: {
          vertical: 'top',
          horizontal: 'center'
        },
        hintData: this.renderCopyToClipboardHintContent(),
        hintClassName: "copy-hint"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "box m-l-10",
        onClick: this.handleCopyToClipboard
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-copy"
      }))));
    }
  }]);
  return _CopyBox;
}(_react.PureComponent);

(0, _defineProperty2.default)(_CopyBox, "propTypes", {
  text: _propTypes.default.string.isRequired,
  textToCopy: _propTypes.default.string,
  copyToClipboardText: _propTypes.default.string,
  intl: _shapes.intlShape.isRequired
});
(0, _defineProperty2.default)(_CopyBox, "defaultProps", {
  copyToClipboardText: null,
  textToCopy: null
});
var CopyBox = (0, _reactIntl.injectIntl)(_CopyBox);
exports.CopyBox = CopyBox;
//# sourceMappingURL=index.js.map